import { Language } from "./types";

export const adminTranslations: Record<Language, Record<string, string>> = {
  en: {
    adminTitle: "Admin Control Center",
    operationsHub: "Operations Hub",
    personnel: "Personnel",
    intelligence: "Intelligence",
    notices: "Notices",
    securityAlerts: "Security Alerts",
    analytics: "Analytics",
    authorizing: "Authorizing Admin Session...",
    exportIntel: "Export Intelligence",
    recentAgents: "Recent Agents",
    networkSecure: "Network Secure",
    allVerified: "All intelligence streams are currently verified",
    deletePersonnel: "Delete Personnel Record?",
    deleteDesc: "This will permanently wipe all intelligence, logs, and profile data associated with this scout.",
    terminateUser: "TERMINATE USER",
    terminateBroadcast: "Terminate Broadcast?",
    deleteBroadcastDesc:
      "Are you sure you want to delete this content permanently? This action cannot be undone and it will be removed from the global feed.",
    changeAccess: "Change Access Level?",
    accessLevelDesc: "Modify personnel access level. This updates security clearance immediately.",
    incidentReport: "Incident Report",
    reporterTestimony: "Reporter Testimony",
    noTestimony: "No extra testimony logged.",
    auditLog: "Full Audit",
    modifyPerms: "Modify Permissions",
    alerts: "System Alerts",
    noAlerts: "No recent alerts in the last 3 days",
    newAgent: "New Agent Recruited",
    reportFiled: "Security Report Filed",
    justNow: "Just now",
    threeDaysAlert: "Showing alerts from the last 72 hours",
    overview: "Overview",
    users: "Users",
    content: "Content",
    settings: "Settings",
    adminControl: "Admin Control",
    exitConsole: "Exit Console",
    opsHubDesc: "Network traffic and personnel analytics",
    personnelAlerts: "Personnel Alerts",
    totalAgents: "Total Agents",
    intelFeed: "Intel Feed",
    activeReports: "Active Reports",
    growthAnalytics: "Growth Analytics",
    growthDesc: "Comparing New Recruits vs Intelligence activity",
    activeSectors: "Active Sectors",
    sectorDesc: "Intelligence distribution by league",
    recentPersonnel: "Recent Agents",
    personnelDesc: "New recruits in the network",
    personnelManageDesc: "Manage global scouting network members",
    noResultsFound: "No results found",
    viewAll: "View All",
    activeFans: "Active Fans",
    feedActivity: "Feed Activity",
    newAgents: "New Agents",
    communityActivity: "Community Talk",
    totalCommentsReplies: "Total comments & replies",
    safetyClearance: "Safety clearance: 98%",
    securityAlertsDesc: "Reported intelligence breaches",
    accessLevel: "Access Level",
    recruitmentDate: "Recruitment Date",
    broadcastingAsset: "Broadcasting Asset",
    sector: "Sector",
    riskLevel: "Risk Level",
    timestamp: "Timestamp",
    ops: "Ops",
    searchPersonnel: "Search by name, email or ID...",
    searchBroadcast: "Search broadcast title or source...",
    critical: "Critical",
    secure: "Secure",
    last7days: "Last 7 days",
    last30days: "Last 30 days",
    last3months: "Last 3 months",
    createNotice: "Create Notice",
    filterDate: "Filter Date",
    allActivities: "Total",
    hide: "Hide",
    unhide: "Unhide",
    hidden: "Hidden",
    visibilityChanged: "Visibility updated",
    save: "Save",
    systemProtocols: "System Protocols",
    maintenanceMode: "Maintenance Mode",
    maintenanceDesc: "Suspend all public intelligence streams",
    guestIntelligence: "Guest Intelligence",
    guestIntelDesc: "Allow unverified scouts to submit reports",
    aiNeuralEngine: "AI Neural Engine",
    primaryModel: "Primary Analytical Model",
    reportLength: "Report Generation Length",
    latencyOptimizations: "Engine Latency Optimizations",
    latencyDesc: "Current analytics are utilizing Thinking tokens for enhanced tactical accuracy.",
    coreRepository: "Core Repository",
    hostStatus: "Host Status",
    cacheDensity: "Cache Density",
    logRetention: "Log Retention",
    flushCache: "Flush System Cache",
    securityCredentials: "Security Credentials",
    operational: "Operational",
    configSaved: "System configuration secured.",
    flushConfirm: "Flush global system cache?",
    cachePurged: "Cache purged successfully.",
    inquiries: "Inquiries",
    players: "Players",
    playerAndTransferManagement: "Player & Transfer Management",
    playerManagementDesc: "Manage transfer market data and player profiles",
    latestTransfers: "Latest Transfers",
    topTransfers: "Top Transfers",
    groupList: "Group List",
    playerSearchPlaceholder: "Search by player or team...",
    addItem: "Add Item",
    playerIntel: "Player Intel",
    movement: "Movement",
    valueFee: "Value / Fee",
    noItemsFound: "No items found",
    createGroup: "Create Group",
    editGroup: "Edit Group",
    addPersonnel: "Add Player",
    editPersonnel: "Edit Player",
    deleteGroup: "Delete Group",
    deleteItem: "Delete Item",
    deleteGroupConfirmDesc: "Are you sure you want to delete this group? All player data within this group will also be deleted.",
    deleteItemConfirmDesc: "Are you sure you want to delete this player data?",
    deleteConfirm: "Confirm Permanent Deletion",
    deleteConfirmDesc: "Are you sure you want to delete this content? Once deleted, it cannot be recovered from the server.",
    selectLeagueDate: "Please select league and date first",
    noGamesFound: "No games found for this date",
    foundGames: "Found {{count}} games",
    gameInfoApplied: "Game info applied",
    highlightUpdated: "Highlight updated",
    highlightCreated: "Highlight created",
    deletedSuccess: "Deleted successfully",
    editShort: "Edit Short",
    newShort: "New Short",
    shortUpdated: "Short updated",
    shortCreated: "Short created",
    highlights: "Highlights",
    manageGamesDesc: "Manage the game store lineup",
    gameCreated: "Game created",
    iconEmoji: "Icon (Emoji)",
    loadInquiriesFailed: "Failed to load inquiries.",
    inquiryStatusUpdated: "Inquiry status updated.",
    updateFailed: "Update failed.",
    intelAsset: "Intel Asset",
    timeline: "Timeline",
    enterContentTranslate: "Please enter content to translate.",
    editCommunication: "Edit Communication",
    newBroadcast: "New Broadcast",
    sysIntelModule: "System Intelligence Module",
    transmissionStart: "Transmission Start",
    transmissionExpiry: "Transmission Expiry",
    activeBanner: "Active Banner",
    aiContentForge: "AI Content Forge",
    assetLibrary: "Asset Library (Reuse System Assets)",
    deployIntelligence: "Deploy Intelligence",
    deleteNotice: "Delete Notice",
    deleteNoticeConfirmDesc: "Are you sure you want to delete this notice? This action cannot be undone.",
    newsArticle: "News Article",
    feedComment: "Feed Comment",
    matchTalk: "Match Talk",
    contentDeleted: "Content deleted successfully.",
    deleteError: "Error processing deletion.",
    reportsConfirmDesc: "Do you want to permanently delete this reported content? This action cannot be undone.",
    approveDeletion: "Approve Deletion",
    manageReportsDesc: "Review and manage all incident reports",
    searchReportsPlaceholder: "Search reason, reporter or content...",
    breachContextReason: "Breach Context / Reason",
    reporter: "Reporter",
    clearingCache: "Clearing system cache...",
    manageSettingsDesc: "Manage system core engine and network policies",
    sysMaintenance: "System Maintenance",
    flushCacheDesc: "Clear all locally cached intelligence data",
    clearing: "Clearing...",
    dbStatus: "Database Status",
    apiNode: "API Node",
    versionControl: "Version Control",
    coreVersion: "Core Version",
    neuralInterface: "Neural Interface",
    highlightsManage: "Highlight Management",
    highlightsDesc: "Manage match highlight videos",
    addNew: "Add New",
    search: "Search...",
    allCountries: "All Countries",
    itemsPerPage: "Items",
    matchInfo: "Match Info",
    embedId: "Embed ID",
    matchId: "Match ID",
    date: "Date",
    editHighlight: "Edit Highlight",
    newHighlight: "New Highlight",
    quickGameSelection: "Quick Game Selection",
    searchLeague: "Search league...",
    selectLeague: "Select League",
    majorLeagues: "Major Leagues",
    searchResults: "Search Results",
    allLeagues: "All Leagues",
    saveHighlight: "Save Highlight",
    shorts: "Shorts",
    shortsManage: "Shorts Management",
    shortsDesc: "Manage YouTube Shorts videos",
    videoId: "Video ID",
    channelName: "Channel Name",
    channelImage: "Channel Image",
    saveShort: "Save Short",
    isHidden: "Is Hidden",
    customerInquiries: "Customer Inquiries",
    manageInquiries: "Manage user support requests",
    allStatus: "All Status",
    pending: "Pending",
    answered: "Answered",
    closed: "Closed",
    noInquiries: "No inquiries found",
    general: "General",
    userInquiry: "User Inquiry",
    adminResponse: "Admin Response",
    writeResponse: "Write your response here...",
    closeWithoutAnswer: "Close without answer",
    sendAnswer: "Send Answer",
    unknown: "Unknown",
    gameStore: "Game Store",
    manageGames: "Manage Games",
    gameTitle: "Game Title",
    category: "Category",
    iconUrl: "Icon URL",
    gameLink: "Game Link",
    isNew: "Is New",
    saveGame: "Save Game",
    newGame: "New Game",
    editGame: "Edit Game",
    source: "Source",
    preview: "Preview",
    edit: "Edit",
    saveChanges: "Save Changes",
    cancel: "Cancel",
    intelligenceBreachAudit: "Intelligence Breach Audit",
    breachOrigin: "Breach Origin",
    reported: "Reported",
    breachTestimony: "Breach Testimony",
    noTestimonyRecorded: "No detailed testimonies recorded",
    closeLog: "Close Log",
    terminateIntelligence: "Terminate Intelligence",
    appearanceInLiveFeed: "Appearance in Live Feed",
    detailPagePreview: "Detail Page Preview",
    titleKo: "Title (KO)",
    titleEn: "Title (EN)",
    summaryKo: "Summary (KO)",
    summaryEn: "Summary (EN)",
    contentKo: "Content (KO)",
    contentEn: "Content (EN)",
    editIntelligence: "Edit Intelligence",
    intelligenceDesc: "Review and manage community shared feeds",
    awardPoints: "Award Points",
    awardPointsDesc: "Award points to the agent.",
    awardSuccess: "points awarded successfully.",
    deleteUserSuccess: "Account and all associated storage data terminated.",
    deleteNewsSuccess: "Article and associated media files (including TTS) permanently deleted.",
    awardAmount: "Amount",
    awardReason: "Reason",
    awardAction: "Award",
    adminReward: "Admin Special Reward",
    refreshPage: "Refresh Current Page",
    refreshSuccess: "Cache cleared and data refreshed.",
    awardPointsUserDesc: "Award points to {{name}}.",
    syncingAlerts: "Syncing Alerts Stream...",
    personnelActivityLogs: "Personnel Activity Logs",
    newsTalk: "News Talk",
    foundCount: "{{count}} Items Found",
    syncingLogs: "Syncing Encrypted Logs...",
    noActivityLogs: "No activity logs recorded",
    page: "Page",
    of: "of",
    breachReport: "Breach Report",
    noSpecificReason: "No specific reason provided",
    scoutId: "Scout ID",
    items: "Items",
    manageNoticesDesc: "Manage system notices and popups",
    syncingIntelHub: "Syncing Intelligence Hub...",
    noActiveCommunications: "No active communications found",
    status: "Status",
    live: "Live",
    offline: "Offline",
    immediate: "Immediate",
    infinite: "Infinite",
    language: "Language",
    korean: "Korean",
    english: "English",
    translateToEn: "Translate to EN",
    translateToKr: "Translate to KR",
    publishStatus: "Publish Status",
    noBannerSelected: "No Banner Selected",
    enterVisualTheme: "Enter visual theme (e.g. Modern stadium at night with neon lights)",
    forgeNewVisual: "Forge New Visual",
    delete: "Delete",
    footyMaster: "Footy Master",
    manageFootyMasterDesc: "Manage DB-based quizzes for FQ Test",
    addNewQuiz: "Add New Quiz",
    searchQuizzes: "Search quizzes or categories...",
    questionKo: "Question (KO)",
    difficulty: "Difficulty",
    langs: "Langs",
    syncingQuizzes: "Syncing Quizzes...",
    noQuizzesFound: "No Quizzes Found",
    editQuiz: "Edit Quiz",
    newQuiz: "New Quiz",
    fqTestDbEntry: "FQ Test Database Entry",
    correctIndex: "Correct Index",
    option: "Option",
    correct: "Correct",
    explanation: "Explanation",
    saveQuizAsset: "Save Quiz Asset",
    deleteQuiz: "Delete Quiz",
    deleteQuizConfirm: "Are you sure you want to permanently delete this quiz? This action cannot be undone.",
    generateWithAI: "Generate with AI",
    aiDraftGenerated: "AI Draft generated (Korean only, please translate or fill others)",
    enterCategoryFirst: "Please enter a category first",
  },
  ko: {
    adminTitle: "관리자 컨트롤 센터",
    operationsHub: "운영 허브",
    personnel: "회원 관리",
    intelligence: "콘텐츠 관리",
    notices: "공지사항 관리",
    securityAlerts: "보안 알림",
    analytics: "통계 분석",
    authorizing: "관리자 세션 인증 중...",
    exportIntel: "데이터 내보내기",
    recentAgents: "최근 가입 요원",
    networkSecure: "네트워크 안전",
    allVerified: "모든 인텔리전스 스트림이 현재 검증되었습니다",
    deletePersonnel: "요원 기록을 삭제하시겠습니까?",
    deleteDesc: "이 작업은 해당 요원과 관련된 모든 인텔리전스, 로그 및 프로필 데이터를 영구적으로 삭제합니다.",
    terminateUser: "사용자 종료",
    terminateBroadcast: "방송을 중단하시겠습니까?",
    deleteBroadcastDesc: "해당 콘텐츠를 영구 삭제하시겠습니까? 이 작업은 되돌릴 수 없으며 글로벌 피드에서 즉시 제거됩니다.",
    changeAccess: "접근 권한을 변경하시겠습니까?",
    accessLevelDesc: "요원의 접근 레벨을 수정합니다. 보안 승인 및 관리 기능이 즉시 업데이트됩니다.",
    incidentReport: "사건 리포트",
    reporterTestimony: "신고자 증언",
    noTestimony: "추가 증언 기록이 없습니다.",
    auditLog: "전체 감사",
    modifyPerms: "권한 수정",
    alerts: "시스템 알림",
    noAlerts: "최근 3일 동안 발생한 알림이 없습니다",
    newAgent: "새로운 요원 영입",
    reportFiled: "보안 리포트 접수",
    justNow: "방금 전",
    threeDaysAlert: "최근 72시간 내의 알림을 표시합니다",
    overview: "개요",
    users: "사용자",
    content: "콘텐츠",
    settings: "설정",
    adminControl: "관리 시스템",
    exitConsole: "콘솔 종료",
    opsHubDesc: "네트워크 트래픽 및 인적 자원 분석",
    personnelAlerts: "요원 경보",
    totalAgents: "전체 요원",
    intelFeed: "인텔 피드",
    activeReports: "활성 리포트",
    growthAnalytics: "성장 지표 분석",
    growthDesc: "신규 가입 대비 인텔리전스 활동량 비교",
    activeSectors: "활성 섹터",
    sectorDesc: "리그별 인텔리전스 분포 현황",
    recentPersonnel: "최근 가입 요원",
    personnelDesc: "네트워크에 새로 합류한 요원",
    securityAlertsDesc: "보고된 인텔리전스 위반 사항",
    accessLevel: "권한 레벨",
    recruitmentDate: "영입 일자",
    broadcastingAsset: "방송 자산",
    sector: "섹터",
    riskLevel: "위험 수준",
    timestamp: "타임스탬프",
    ops: "운영",
    searchPersonnel: "이름, 이메일 또는 ID로 검색...",
    searchBroadcast: "제목 또는 출처로 검색...",
    critical: "위험",
    secure: "안전",
    last7days: "최근 7일",
    last30days: "최근 30일",
    last3months: "최근 3개월",
    createNotice: "공지사항 작성",
    bannerImage: "배너 이미지",
    aiGenerate: "AI 생성",
    filterDate: "날짜 검색",
    allActivities: "총",
    hide: "숨기기",
    unhide: "보이기",
    hidden: "숨김",
    visibilityChanged: "노출 상태가 변경되었습니다",
    save: "설정 저장",
    systemProtocols: "시스템 프로토콜",
    maintenanceMode: "점검 모드",
    maintenanceDesc: "공공 인텔리전스 스트림 중단",
    guestIntelligence: "게스트 인텔리전스",
    guestIntelDesc: "미인증 요원의 리포트 작성 허용",
    aiNeuralEngine: "AI 신경망 엔진",
    primaryModel: "기본 분석 모델",
    reportLength: "리포트 생성 길이",
    latencyOptimizations: "엔진 레이턴시 최적화",
    latencyDesc: "현재 전술적 정확도 향상을 위해 Thinking 토큰을 사용 중입니다.",
    coreRepository: "코어 저장소",
    hostStatus: "호스트 상태",
    cacheDensity: "캐시 밀도",
    logRetention: "로그 보관 기간",
    flushCache: "시스템 캐시 초기화",
    securityCredentials: "보안 인증 정보",
    operational: "정상 작동 중",
    configSaved: "시스템 설정이 저장되었습니다.",
    flushConfirm: "시스템 캐시를 초기화하시겠습니까?",
    cachePurged: "캐시가 삭제되었습니다.",
    inquiries: "1:1 문의",
    personnelManageDesc: "글로벌 스카우팅 네트워크 멤버를 관리합니다",
    noResultsFound: "검색 결과가 없습니다",
    viewAll: "모두 보기",
    activeFans: "활성 팬",
    feedActivity: "피드 활동",
    newAgents: "신규 가입",
    communityActivity: "커뮤니티 활동",
    totalCommentsReplies: "전체 댓글 및 답변",
    safetyClearance: "보안 승인율: 98%",
    players: "선수 관리",
    playerAndTransferManagement: "선수 및 이적 관리",
    playerManagementDesc: "이적 시장 데이터 및 선수 프로필을 관리합니다",
    latestTransfers: "최신 이적",
    topTransfers: "주요 이적",
    groupList: "그룹 목록",
    playerSearchPlaceholder: "선수, 팀 이름으로 검색...",
    addItem: "아이템 추가",
    playerIntel: "선수 정보",
    movement: "이적 경로",
    valueFee: "가치 / 이적료",
    noItemsFound: "표시할 아이템이 없습니다",
    createGroup: "그룹 생성",
    editGroup: "그룹 수정",
    addPersonnel: "선수 추가",
    editPersonnel: "선수 수정",
    deleteGroup: "그룹 삭제",
    deleteItem: "아이템 삭제",
    deleteGroupConfirmDesc: "이 그룹을 삭제하시겠습니까? 그룹 내의 모든 선수 데이터도 함께 삭제됩니다.",
    deleteItemConfirmDesc: "이 선수 데이터를 삭제하시겠습니까?",
    deleteConfirm: "영구 삭제 확인",
    deleteConfirmDesc: "해당 콘텐츠를 정말로 삭제하시겠습니까? 삭제된 데이터는 서버에서 복구할 수 없습니다.",
    selectLeagueDate: "리그와 날짜를 먼저 선택해주세요.",
    noGamesFound: "해당 날짜에 경기가 없습니다.",
    foundGames: "{{count}}개의 경기를 찾았습니다.",
    gameInfoApplied: "경기 정보가 입력되었습니다.",
    highlightUpdated: "하이라이트가 수정되었습니다.",
    highlightCreated: "하이라이트가 등록되었습니다.",
    deletedSuccess: "삭제되었습니다.",
    editShort: "쇼츠 수정",
    newShort: "쇼츠 등록",
    shortUpdated: "쇼츠가 수정되었습니다.",
    shortCreated: "쇼츠가 등록되었습니다.",
    highlights: "하이라이트",
    manageGamesDesc: "게임 스토어의 게임 라인업을 관리합니다",
    gameCreated: "게임이 등록되었습니다.",
    iconEmoji: "아이콘 (이모지)",
    loadInquiriesFailed: "문의 내역을 불러오는데 실패했습니다.",
    inquiryStatusUpdated: "문의 상태가 업데이트되었습니다.",
    updateFailed: "업데이트에 실패했습니다.",
    intelAsset: "인텔 자산",
    timeline: "타임라인",
    enterContentTranslate: "번역할 내용을 입력해주세요.",
    editCommunication: "공지사항 수정",
    newBroadcast: "새로운 브로드캐스트",
    sysIntelModule: "시스템 인텔리전스 모듈",
    transmissionStart: "전송 시작",
    transmissionExpiry: "전송 종료",
    activeBanner: "활성 배너",
    aiContentForge: "AI 콘텐츠 포지",
    assetLibrary: "에셋 라이브러리 (기존 에셋 재사용)",
    deployIntelligence: "인텔리전스 배포",
    deleteNotice: "공지사항 삭제",
    deleteNoticeConfirmDesc: "이 공지사항을 정말로 삭제하시겠습니까? 삭제된 데이터는 복구할 수 없습니다.",
    newsArticle: "뉴스 기사",
    feedComment: "뉴스 댓글",
    matchTalk: "경기 댓글",
    contentDeleted: "콘텐츠가 성공적으로 삭제되었습니다.",
    deleteError: "삭제 처리 중 오류가 발생했습니다.",
    reportsConfirmDesc: "신고된 해당 콘텐츠를 서버에서 영구적으로 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
    approveDeletion: "삭제 승인",
    manageReportsDesc: "모든 신고 접수 내역을 검토하고 관리합니다",
    searchReportsPlaceholder: "사유, 신고자 또는 내용 검색...",
    breachContextReason: "위반 맥락 / 사유",
    reporter: "신고자",
    clearingCache: "시스템 캐시 초기화 중...",
    manageSettingsDesc: "시스템 코어 엔진 및 네트워크 정책을 관리합니다",
    sysMaintenance: "시스템 유지보수",
    flushCacheDesc: "모든 로컬 캐시 데이터를 초기화합니다",
    clearing: "초기화 중...",
    dbStatus: "데이터베이스 상태",
    apiNode: "API 노드",
    versionControl: "버전 관리",
    coreVersion: "코어 버전",
    neuralInterface: "신경망 인터페이스",
    highlightsManage: "영상 하이라이트 관리",
    highlightsDesc: "경기 하이라이트 영상을 관리합니다",
    addNew: "신규 등록",
    search: "검색...",
    allCountries: "모든 국가",
    itemsPerPage: "개씩 보기",
    matchInfo: "경기 정보",
    embedId: "임베드 ID",
    matchId: "경기 ID",
    date: "날짜",
    editHighlight: "하이라이트 수정",
    newHighlight: "하이라이트 등록",
    quickGameSelection: "빠른 경기 선택",
    searchLeague: "리그 검색...",
    selectLeague: "리그 선택",
    majorLeagues: "주요 리그",
    searchResults: "검색 결과",
    allLeagues: "전체 리그",
    saveHighlight: "저장하기",
    shorts: "쇼츠",
    shortsManage: "쇼츠 관리",
    shortsDesc: "YouTube 쇼츠 영상을 관리합니다",
    videoId: "비디오 ID",
    channelName: "채널명",
    channelImage: "채널 이미지",
    saveShort: "저장하기",
    isHidden: "숨김 여부",
    customerInquiries: "고객 문의 내역",
    manageInquiries: "사용자 지원 요청을 관리합니다",
    allStatus: "전체 상태",
    pending: "대기 중",
    answered: "답변 완료",
    closed: "종료됨",
    noInquiries: "문의 내역이 없습니다",
    general: "일반",
    userInquiry: "사용자 문의 내용",
    adminResponse: "관리자 답변",
    writeResponse: "답변 내용을 입력하세요...",
    closeWithoutAnswer: "답변 없이 종료",
    sendAnswer: "답변 전송",
    unknown: "알 수 없음",
    gameStore: "게임 스토어",
    manageGames: "게임 스토어 관리",
    gameTitle: "게임 제목",
    category: "카테고리",
    iconUrl: "아이콘 URL",
    gameLink: "게임 링크",
    isNew: "신규 게임",
    saveGame: "게임 저장",
    newGame: "게임 등록",
    editGame: "게임 수정",
    source: "출처",
    preview: "미리보기",
    edit: "수정",
    saveChanges: "변경사항 저장",
    cancel: "취소",
    intelligenceBreachAudit: "콘텐츠 위반 감사",
    breachOrigin: "위반 출처",
    reported: "신고됨",
    breachTestimony: "위반 증언",
    noTestimonyRecorded: "기록된 상세 증언이 없습니다",
    closeLog: "로그 닫기",
    terminateIntelligence: "콘텐츠 영구 삭제",
    appearanceInLiveFeed: "실제 피드 노출 모습",
    detailPagePreview: "상세 페이지 미리보기",
    titleKo: "제목 (국문)",
    titleEn: "제목 (영문)",
    summaryKo: "요약 (국문)",
    summaryEn: "요약 (영문)",
    contentKo: "상세 내용 (국문)",
    contentEn: "상세 내용 (영문)",
    editIntelligence: "콘텐츠 수정",
    intelligenceDesc: "커뮤니티에서 공유된 피드를 검토하고 관리합니다",
    awardPoints: "포인트 지급",
    awardPointsDesc: "요원에게 포인트를 지급합니다.",
    awardSuccess: "포인트가 지급되었습니다.",
    deleteUserSuccess: "계정 및 모든 스토리지 데이터가 삭제되었습니다.",
    deleteNewsSuccess: "기사 및 관련 미디어 파일(TTS 포함)이 영구 삭제되었습니다.",
    awardAmount: "지급 수량",
    awardReason: "지급 사유",
    awardAction: "지급하기",
    adminReward: "운영자 특별 보상",
    refreshPage: "현재 페이지 새로고침",
    refreshSuccess: "캐시를 초기화하고 데이터를 새로 불러왔습니다.",
    awardPointsUserDesc: "{{name}}님에게 포인트를 지급합니다.",
    syncingAlerts: "알림 스트림 동기화 중...",
    personnelActivityLogs: "요원 활동 로그",
    newsTalk: "뉴스 댓글",
    foundCount: "{{count}}개의 항목을 찾았습니다.",
    syncingLogs: "암호화된 로그 동기화 중...",
    noActivityLogs: "기록된 활동 로그가 없습니다",
    page: "페이지",
    of: "/",
    breachReport: "위반 리포트",
    noSpecificReason: "상세 사유가 제공되지 않았습니다",
    scoutId: "요원 ID",
    items: "개",
    manageNoticesDesc: "시스템 공지사항 및 팝업을 관리합니다",
    syncingIntelHub: "인텔리전스 허브 동기화 중...",
    noActiveCommunications: "활성화된 공지사항이 없습니다",
    status: "상태",
    live: "라이브",
    offline: "오프라인",
    immediate: "즉시",
    infinite: "무기한",
    language: "언어",
    korean: "한국어",
    english: "영어",
    translateToEn: "영문 번역",
    translateToKr: "국문 번역",
    publishStatus: "게시 상태",
    noBannerSelected: "선택된 배너 없음",
    enterVisualTheme: "시각적 테마 입력 (예: 네온 조명이 있는 밤의 현대적인 경기장)",
    forgeNewVisual: "새 이미지 생성",
    delete: "삭제",
    footyMaster: "푸티 마스터",
    manageFootyMasterDesc: "FQ 테스트를 위한 DB 기반 퀴즈 관리",
    addNewQuiz: "신규 퀴즈 등록",
    searchQuizzes: "퀴즈 또는 카테고리 검색...",
    questionKo: "문제 (국문)",
    difficulty: "난이도",
    langs: "언어",
    syncingQuizzes: "퀴즈 동기화 중...",
    noQuizzesFound: "퀴즈를 찾을 수 없습니다",
    editQuiz: "퀴즈 수정",
    newQuiz: "신규 퀴즈",
    fqTestDbEntry: "FQ 테스트 데이터베이스 엔트리",
    correctIndex: "정답 인덱스",
    option: "보기",
    correct: "정답",
    explanation: "해설",
    saveQuizAsset: "퀴즈 자산 저장",
    deleteQuiz: "퀴즈 삭제",
    deleteQuizConfirm: "이 퀴즈를 정말로 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
    generateWithAI: "AI로 생성",
    aiDraftGenerated: "AI 초안이 생성되었습니다 (국문 전용, 타 언어는 직접 입력 필요)",
    enterCategoryFirst: "카테고리를 먼저 입력해주세요",
  },
  ja: {
    adminTitle: "管理者コントロールセンター",
    operationsHub: "運用ハブ",
    personnel: "メンバー管理",
    intelligence: "コンテンツ管理",
    notices: "お知らせ管理",
    securityAlerts: "セキュリティ通知",
    analytics: "統計分析",
    authorizing: "管理者セッション認証中...",
    exportIntel: "データ出力",
    recentAgents: "最近の登録エージェント",
    networkSecure: "ネットワーク安全",
    allVerified: "すべてのインテリジェンスが検証済みです",
    deletePersonnel: "エージェント記録を削除しますか？",
    deleteDesc: "この操作は、該当エージェントに関連するすべてのインテリジェンス、ログ、プロフィールデータを永久に削除します。",
    terminateUser: "ユーザー終了",
    terminateBroadcast: "放送を中止しますか？",
    deleteBroadcastDesc: "該当コンテンツを永久に削除しますか？この操作は取り消せず、グローバルフィードから即座に削除されます。",
    changeAccess: "アクセス権限を変更しますか？",
    accessLevelDesc: "エージェントのアクセスレベルを修正します。セキュリティ承認と管理機能が即座に更新されます。",
    incidentReport: "事件レポート",
    reporterTestimony: "報告者の証言",
    noTestimony: "追加の証言記録はありません。",
    auditLog: "完全監査",
    modifyPerms: "権限修正",
    alerts: "システムアラート",
    noAlerts: "最近3日間のアラートはありません",
    newAgent: "新しいエージェントが加入しました",
    reportFiled: "セキュリティレポート受理",
    justNow: "たった今",
    threeDaysAlert: "最近72時間のアラートを表示しています",
    overview: "概要",
    users: "ユーザー",
    content: "コンテンツ",
    settings: "設定",
    adminControl: "管理システム",
    exitConsole: "コンソール終了",
    opsHubDesc: "ネットワークトラフィックと人的資源の分析",
    personnelAlerts: "エージェント警告",
    totalAgents: "全エージェント",
    intelFeed: "インテルフィード",
    activeReports: "有効なレポート",
    growthAnalytics: "成長指標分析",
    growthDesc: "新規登録数とインテリジェンス活動量の比較",
    activeSectors: "有効セクター",
    sectorDesc: "リーグ別インテリジェンス分布",
    recentPersonnel: "最近のエージェント",
    personnelDesc: "ネットワークに新しく合流したエージェント",
    personnelManageDesc: "グローバルスカウティングネットワークメンバーを管理します",
    noResultsFound: "結果が見つかりません",
    viewAll: "すべて表示",
    activeFans: "アクティブファン",
    feedActivity: "フィード活動",
    newAgents: "新規加入",
    communityActivity: "コミュニティトーク",
    totalCommentsReplies: "総コメント＆返信",
    safetyClearance: "安全承認率: 98%",
    securityAlertsDesc: "報告されたインテリジェンス違反",
    accessLevel: "権限レベル",
    recruitmentDate: "加入日",
    broadcastingAsset: "放送アセット",
    sector: "セクター",
    riskLevel: "リスクレベル",
    timestamp: "タイムスタンプ",
    ops: "運用",
    searchPersonnel: "名前、メール、IDで検索...",
    searchBroadcast: "タイトル、出典で検索...",
    critical: "危険",
    secure: "安全",
    last7days: "最近7日間",
    last30days: "最近30日間",
    last3months: "最近3ヶ月",
    createNotice: "お知らせ作成",
    filterDate: "日付検索",
    allActivities: "合計",
    hide: "非表示",
    unhide: "表示",
    hidden: "非表示中",
    visibilityChanged: "露出状態が更新されました",
    save: "保存",
    systemProtocols: "システムプロトコル",
    maintenanceMode: "メンテナンスモード",
    maintenanceDesc: "公開インテリジェンスのストップ",
    guestIntelligence: "ゲストインテリジェンス",
    guestIntelDesc: "未認証エージェントのレポート投稿を許可",
    aiNeuralEngine: "AIニューラルエンジン",
    primaryModel: "基本分析モデル",
    reportLength: "レポート生成長",
    latencyOptimizations: "エンジン遅延の最適化",
    latencyDesc: "現在、戦術的精度の向上のためにThinkingトークンを使用しています。",
    coreRepository: "コアリポジトリ",
    hostStatus: "ホスト状態",
    cacheDensity: "キャッシュ密度",
    logRetention: "ログ保持期間",
    flushCache: "キャッシュ削除",
    securityCredentials: "認証情報",
    operational: "正常稼働中",
    configSaved: "システム設定が保存されました。",
    flushConfirm: "キャッシュを初期化しますか？",
    cachePurged: "キャッシュが削除されました。",
    inquiries: "1:1 お問い合わせ",
    players: "選手管理",
    playerAndTransferManagement: "選手＆移籍管理",
    playerManagementDesc: "移籍市場データと選手プロフィールの管理",
    latestTransfers: "最近の移籍",
    topTransfers: "主要な移籍",
    groupList: "グループリスト",
    playerSearchPlaceholder: "選手、チーム名で検索...",
    addItem: "アイテム追加",
    playerIntel: "選手インテル",
    movement: "移籍経路",
    valueFee: "価値 / 移籍金",
    noItemsFound: "アイテムが見つかりません",
    createGroup: "グループ作成",
    editGroup: "グループ編集",
    addPersonnel: "選手追加",
    editPersonnel: "選手編集",
    deleteGroup: "グループ削除",
    deleteItem: "アイテム削除",
    deleteGroupConfirmDesc: "このグループを削除しますか？グループ内のすべてのデータも永久に削除されます。",
    deleteItemConfirmDesc: "この選手データを削除しますか？",
    deleteConfirm: "永久削除の確認",
    deleteConfirmDesc: "該当コンテンツを本当に削除しますか？削除されたデータは復旧できません。",
    selectLeagueDate: "リーグと日付を先に選択してください。",
    noGamesFound: "該当する日付に試合がありません。",
    foundGames: "{{count}}件の試合が見つかりました。",
    gameInfoApplied: "試合情報が適用されました。",
    highlightUpdated: "ハイライトが更新されました。",
    highlightCreated: "ハイライトが登録されました。",
    deletedSuccess: "削除されました。",
    editShort: "ショーツ編集",
    newShort: "ショーツ登録",
    shortUpdated: "ショーツが更新されました。",
    shortCreated: "ショーツが登録されました。",
    highlights: "ハイライト",
    manageGamesDesc: "ゲームストアのラインナップ管理",
    gameCreated: "ゲームが登録されました。",
    iconEmoji: "アイコン (絵文字)",
    loadInquiriesFailed: "お問い合わせの読み込みに失敗しました。",
    inquiryStatusUpdated: "お問い合わせステータスが更新されました。",
    updateFailed: "更新に失敗しました。",
    intelAsset: "インテルアセット",
    timeline: "タイムライン",
    enterContentTranslate: "翻訳する内容を入力してください。",
    editCommunication: "お知らせ編集",
    newBroadcast: "新しいブロードキャスト",
    sysIntelModule: "システムインテルモジュール",
    transmissionStart: "送信開始",
    transmissionExpiry: "送信終了",
    activeBanner: "有効なバナー",
    aiContentForge: "AIコンテンツフォージ",
    assetLibrary: "アセットライブラリ",
    deployIntelligence: "インテル配備",
    deleteNotice: "お知らせ削除",
    deleteNoticeConfirmDesc: "このお知らせを本当に削除しますか？削除されたデータは復旧できません。",
    newsArticle: "ニュース記事",
    feedComment: "ニュースコメント",
    matchTalk: "試合トーク",
    contentDeleted: "コンテンツが正常に削除されました。",
    deleteError: "削除処理中にエラーが発生しました。",
    reportsConfirmDesc: "報告された該当コンテンツを永久に削除しますか？この操作は取り消せません。",
    approveDeletion: "削除承認",
    manageReportsDesc: "すべての報告内容を検討・管理します",
    searchReportsPlaceholder: "理由、報告者、内容で検索...",
    breachContextReason: "違反の背景 / 理由",
    reporter: "報告者",
    clearingCache: "キャッシュ初期化中...",
    manageSettingsDesc: "システムコアエンジンとネットワークポリシーを管理します",
    sysMaintenance: "システムメンテナンス",
    flushCacheDesc: "すべてのローカルキャッシュを初期化します",
    clearing: "初期化中...",
    dbStatus: "データベース状態",
    apiNode: "APIノード",
    versionControl: "バージョン管理",
    coreVersion: "コアバージョン",
    neuralInterface: "ニューラルインターフェース",
    highlightsManage: "ハイライト管理",
    highlightsDesc: "試合ハイライト動画を管理します",
    addNew: "新規登録",
    search: "検索...",
    allCountries: "すべての国",
    itemsPerPage: "個ずつ表示",
    matchInfo: "試合情報",
    embedId: "埋め込みID",
    matchId: "試合ID",
    date: "日付",
    editHighlight: "ハイライト編集",
    newHighlight: "ハイライト登録",
    quickGameSelection: "クイック試合選択",
    searchLeague: "リーグ検索...",
    selectLeague: "リーグ選択",
    majorLeagues: "主要リーグ",
    searchResults: "検索結果",
    allLeagues: "すべてのリーグ",
    saveHighlight: "保存する",
    shorts: "ショーツ",
    shortsManage: "ショーツ管理",
    shortsDesc: "YouTubeショーツ動画を管理します",
    videoId: "ビデオID",
    channelName: "チャンネル名",
    channelImage: "チャンネル画像",
    saveShort: "保存する",
    isHidden: "隠す",
    customerInquiries: "カスタマーお問い合わせ",
    manageInquiries: "ユーザーサポートリクエストを管理します",
    allStatus: "すべてのステータス",
    pending: "保留中",
    answered: "回答済み",
    closed: "終了",
    noInquiries: "お問い合わせはありません",
    general: "一般",
    userInquiry: "ユーザーお問い合わせ",
    adminResponse: "管理者回答",
    writeResponse: "回答を入力してください...",
    closeWithoutAnswer: "回答せずに終了",
    sendAnswer: "回答送信",
    unknown: "不明",
    gameStore: "ゲームストア",
    manageGames: "ゲーム管理",
    gameTitle: "ゲームタイトル",
    category: "カテゴリ",
    iconUrl: "アイコンURL",
    gameLink: "ゲームリンク",
    isNew: "新規",
    saveGame: "ゲーム保存",
    newGame: "新規ゲーム",
    editGame: "ゲーム編集",
    source: "出典",
    preview: "プレビュー",
    edit: "編集",
    saveChanges: "変更を保存",
    cancel: "キャンセル",
    intelligenceBreachAudit: "違反監査",
    breachOrigin: "違反元",
    reported: "報告済み",
    breachTestimony: "違反証言",
    noTestimonyRecorded: "詳細な証言は記録されていません",
    closeLog: "ログを閉じる",
    terminateIntelligence: "コンテンツ永久削除",
    appearanceInLiveFeed: "実際の表示形式",
    detailPagePreview: "詳細ページプレビュー",
    titleKo: "タイトル (韓)",
    titleEn: "タイトル (英)",
    summaryKo: "要約 (韓)",
    summaryEn: "要約 (英)",
    contentKo: "内容 (韓)",
    contentEn: "内容 (英)",
    editIntelligence: "コンテンツ編集",
    intelligenceDesc: "コミュニティフィードの検討・管理",
    awardPoints: "ポイント付与",
    awardPointsDesc: "エージェントにポイントを付与します。",
    awardSuccess: "ポイントが付与されました。",
    deleteUserSuccess: "アカウントとすべてのデータが削除されました。",
    deleteNewsSuccess: "記事と関連ファイルが永久に削除されました。",
    awardAmount: "数量",
    awardReason: "理由",
    awardAction: "付与する",
    adminReward: "運営者特別報酬",
    refreshPage: "ページ更新",
    refreshSuccess: "キャッシュが初期化され、データが更新されました。",
    awardPointsUserDesc: "{{name}}さんにポイントを付与します。",
    syncingAlerts: "アラート同期中...",
    personnelActivityLogs: "活動ログ",
    newsTalk: "ニュースコメント",
    foundCount: "{{count}}件見つかりました",
    syncingLogs: "ログ同期中...",
    noActivityLogs: "活動ログはありません",
    page: "ページ",
    of: "/",
    breachReport: "違反レポート",
    noSpecificReason: "詳細な理由は提供されていません",
    scoutId: "エージェントID",
    items: "個",
    manageNoticesDesc: "システムお知らせとポップアップの管理",
    syncingIntelHub: "インテルハブ同期中...",
    noActiveCommunications: "有効なお知らせはありません",
    status: "ステータス",
    live: "ライブ",
    offline: "オフライン",
    immediate: "即時",
    infinite: "無期限",
    language: "言語",
    korean: "韓国語",
    english: "英語",
    translateToEn: "英語に翻訳",
    translateToKr: "韓国語に翻訳",
    publishStatus: "公開設定",
    noBannerSelected: "バナー未選択",
    enterVisualTheme: "視覚的テーマを入力してください",
    forgeNewVisual: "新規画像生成",
    delete: "削除",
    footyMaster: "フッティーマスター",
    manageFootyMasterDesc: "FQテスト用のDBベースのクイズ管理",
    addNewQuiz: "新規クイズ登録",
    searchQuizzes: "クイズまたはカテゴリを検索...",
    questionKo: "問題 (韓国語)",
    difficulty: "難易度",
    langs: "言語",
    syncingQuizzes: "クイズ同期中...",
    noQuizzesFound: "クイズが見つかりません",
    editQuiz: "クイズ編集",
    newQuiz: "新規クイズ",
    fqTestDbEntry: "FQテストデータベースエントリ",
    correctIndex: "正解インデックス",
    option: "選択肢",
    correct: "正解",
    explanation: "解説",
    saveQuizAsset: "クイズアセットを保存",
    deleteQuiz: "クイズ削除",
    deleteQuizConfirm: "このクイズを本当に削除しますか？この操作は取り消せません。",
    generateWithAI: "AIで生成",
    aiDraftGenerated: "AIドラフトが生成されました（韓国語のみ、他言語は入力が必要）",
    enterCategoryFirst: "カテゴリを先に入力してください",
  },
  es: {
    adminTitle: "Centro de Control Admin",
    operationsHub: "Hub de Operaciones",
    personnel: "Personal",
    intelligence: "Inteligencia",
    notices: "Avisos",
    securityAlerts: "Alertas de Seguridad",
    analytics: "Analítica",
    authorizing: "Autorizando sesión...",
    exportIntel: "Exportar Inteligencia",
    recentAgents: "Agentes Recientes",
    networkSecure: "Red Segura",
    allVerified: "Todas las transmisiones verificadas",
    deletePersonnel: "¿Borrar registro de personal?",
    deleteDesc: "Esto borrará permanentemente todos los datos asociados a este scout.",
    terminateUser: "TERMINAR USUARIO",
    terminateBroadcast: "¿Terminar emisión?",
    deleteBroadcastDesc: "¿Seguro que quieres borrar este contenido? No se puede deshacer.",
    changeAccess: "¿Cambiar nivel de acceso?",
    accessLevelDesc: "Modifica el nivel de acceso del personal.",
    incidentReport: "Informe de Incidente",
    reporterTestimony: "Testimonio del Informante",
    noTestimony: "Sin testimonios adicionales.",
    auditLog: "Auditoría Completa",
    modifyPerms: "Modificar Permisos",
    alerts: "Alertas del Sistema",
    noAlerts: "Sin alertas en los últimos 3 días",
    newAgent: "Nuevo Agente Reclutado",
    reportFiled: "Informe de Seguridad Presentado",
    justNow: "Ahora mismo",
    threeDaysAlert: "Mostrando alertas de las últimas 72 horas",
    overview: "Resumen",
    users: "Usuarios",
    content: "Contenido",
    settings: "Ajustes",
    adminControl: "Control Admin",
    exitConsole: "Salir de Consola",
    opsHubDesc: "Tráfico de red y analítica de personal",
    personnelAlerts: "Alertas de Personal",
    totalAgents: "Total Agentes",
    intelFeed: "Feed de Inteligencia",
    activeReports: "Informes Activos",
    growthAnalytics: "Analítica de Crecimiento",
    growthDesc: "Comparativa de reclutas vs actividad",
    activeSectors: "Sectores Activos",
    sectorDesc: "Distribución por liga",
    recentPersonnel: "Agentes Recientes",
    personnelDesc: "Nuevos reclutas en la red",
    personnelManageDesc: "Gestiona los miembros de la red global",
    noResultsFound: "Sin resultados",
    viewAll: "Ver Todo",
    activeFans: "Fans Activos",
    feedActivity: "Actividad del Feed",
    newAgents: "Nuevos Agentes",
    communityActivity: "Charla Comunidad",
    totalCommentsReplies: "Total comentarios y respuestas",
    safetyClearance: "Seguridad: 98%",
    securityAlertsDesc: "Brechas de inteligencia reportadas",
    accessLevel: "Nivel de Acceso",
    recruitmentDate: "Fecha de Reclutamiento",
    broadcastingAsset: "Activo de Emisión",
    sector: "Sector",
    riskLevel: "Nivel de Riesgo",
    timestamp: "Timestamp",
    ops: "Ops",
    searchPersonnel: "Buscar por nombre, email o ID...",
    searchBroadcast: "Buscar por título o fuente...",
    critical: "Crítico",
    secure: "Seguro",
    last7days: "Últimos 7 días",
    last30days: "Últimos 30 días",
    last3months: "Últimos 3 meses",
    createNotice: "Crear Aviso",
    filterDate: "Filtrar Fecha",
    allActivities: "Total",
    hide: "Ocultar",
    unhide: "Mostrar",
    hidden: "Oculto",
    visibilityChanged: "Visibilidad actualizada",
    save: "Guardar",
    systemProtocols: "Protocolos",
    maintenanceMode: "Modo Mantenimiento",
    maintenanceDesc: "Suspender transmisiones públicas",
    guestIntelligence: "Inteligencia Invitada",
    guestIntelDesc: "Permitir informes de scouts no verificados",
    aiNeuralEngine: "Motor Neuronal IA",
    primaryModel: "Modelo Principal",
    reportLength: "Longitud de Informes",
    latencyOptimizations: "Optimización de Latencia",
    latencyDesc: "Usando tokens de pensamiento para mayor precisión.",
    coreRepository: "Repositorio Central",
    hostStatus: "Estado Host",
    cacheDensity: "Densidad Cache",
    logRetention: "Retención Logs",
    flushCache: "Limpiar Cache",
    securityCredentials: "Credenciales",
    operational: "Operativo",
    configSaved: "Configuración guardada.",
    flushConfirm: "¿Limpiar cache global?",
    cachePurged: "Cache limpiada con éxito.",
    inquiries: "Consultas",
    players: "Jugadores",
    playerAndTransferManagement: "Gestión de Jugadores",
    playerManagementDesc: "Datos de mercado y perfiles",
    latestTransfers: "Últimos Fichajes",
    topTransfers: "Principales Fichajes",
    groupList: "Lista de Grupos",
    playerSearchPlaceholder: "Buscar por jugador o equipo...",
    addItem: "Añadir Item",
    playerIntel: "Info Jugador",
    movement: "Movimiento",
    valueFee: "Valor / Precio",
    noItemsFound: "Sin items encontrados",
    createGroup: "Crear Grupo",
    editGroup: "Editar Grupo",
    addPersonnel: "Añadir Jugador",
    editPersonnel: "Editar Jugador",
    deleteGroup: "Borrar Grupo",
    deleteItem: "Borrar Item",
    deleteGroupConfirmDesc: "¿Borrar grupo? Se borrarán todos sus datos.",
    deleteItemConfirmDesc: "¿Borrar datos de jugador?",
    deleteConfirm: "Confirmar Borrado",
    deleteConfirmDesc: "¿Seguro? No se podrá recuperar del servidor.",
    selectLeagueDate: "Selecciona liga y fecha primero",
    noGamesFound: "Sin partidos para esta fecha",
    foundGames: "{{count}} partidos encontrados",
    gameInfoApplied: "Info aplicada",
    highlightUpdated: "Highlight actualizado",
    highlightCreated: "Highlight creado",
    deletedSuccess: "Borrado con éxito",
    editShort: "Editar Short",
    newShort: "Nuevo Short",
    shortUpdated: "Short actualizado",
    shortCreated: "Short creado",
    highlights: "Highlights",
    manageGamesDesc: "Gestiona el catálogo de juegos",
    gameCreated: "Juego creado",
    iconEmoji: "Icono (Emoji)",
    loadInquiriesFailed: "Error al cargar consultas.",
    inquiryStatusUpdated: "Estado actualizado.",
    updateFailed: "Fallo al actualizar.",
    intelAsset: "Activo Intel",
    timeline: "Cronología",
    enterContentTranslate: "Introduce contenido a traducir.",
    editCommunication: "Editar Comunicación",
    newBroadcast: "Nueva Emisión",
    sysIntelModule: "Módulo Intel",
    transmissionStart: "Inicio Transmisión",
    transmissionExpiry: "Fin Transmisión",
    activeBanner: "Banner Activo",
    aiContentForge: "Forja IA",
    assetLibrary: "Librería de Activos",
    deployIntelligence: "Desplegar Inteligencia",
    deleteNotice: "Borrar Aviso",
    deleteNoticeConfirmDesc: "¿Borrar este aviso? Es irreversible.",
    newsArticle: "Artículo de Noticia",
    feedComment: "Comentario de Feed",
    matchTalk: "Chat de Partido",
    contentDeleted: "Contenido borrado con éxito.",
    deleteError: "Error al borrar.",
    reportsConfirmDesc: "¿Borrar contenido reportado permanentemente?",
    approveDeletion: "Aprobar Borrado",
    manageReportsDesc: "Gestiona reportes de incidentes",
    searchReportsPlaceholder: "Buscar por razón, informante...",
    breachContextReason: "Contexto / Razón",
    reporter: "Informante",
    clearingCache: "Limpiando cache...",
    manageSettingsDesc: "Gestiona motor y políticas",
    sysMaintenance: "Mantenimiento",
    flushCacheDesc: "Borrar datos cacheados localmente",
    clearing: "Limpiando...",
    dbStatus: "Estado DB",
    apiNode: "Nodo API",
    versionControl: "Control Versión",
    coreVersion: "Versión Core",
    neuralInterface: "Interfaz Neuronal",
    highlightsManage: "Gestión Highlights",
    highlightsDesc: "Gestiona vídeos de highlights",
    addNew: "Añadir Nuevo",
    search: "Buscar...",
    allCountries: "Todos los Países",
    itemsPerPage: "Items",
    matchInfo: "Info Partido",
    embedId: "ID Embed",
    matchId: "ID Partido",
    date: "Fecha",
    editHighlight: "Editar Highlight",
    newHighlight: "Nuevo Highlight",
    quickGameSelection: "Selección Rápida",
    searchLeague: "Buscar liga...",
    selectLeague: "Elegir Liga",
    majorLeagues: "Ligas Mayores",
    searchResults: "Resultados",
    allLeagues: "Todas las Ligas",
    saveHighlight: "Guardar Highlight",
    shorts: "Shorts",
    shortsManage: "Gestión Shorts",
    shortsDesc: "Gestiona vídeos cortos de YouTube",
    videoId: "ID Vídeo",
    channelName: "Canal",
    channelImage: "Imagen Canal",
    saveShort: "Guardar Short",
    isHidden: "Oculto",
    customerInquiries: "Consultas Clientes",
    manageInquiries: "Gestiona soporte",
    allStatus: "Todos los Estados",
    pending: "Pendiente",
    answered: "Respondido",
    closed: "Cerrado",
    noInquiries: "Sin consultas",
    general: "General",
    userInquiry: "Consulta Usuario",
    adminResponse: "Respuesta Admin",
    writeResponse: "Escribe tu respuesta...",
    closeWithoutAnswer: "Cerrar sin respuesta",
    sendAnswer: "Enviar Respuesta",
    unknown: "Desconocido",
    gameStore: "Game Store",
    manageGames: "Gestionar Juegos",
    gameTitle: "Título Juego",
    category: "Categoría",
    iconUrl: "URL Icono",
    gameLink: "Enlace Juego",
    isNew: "Es Nuevo",
    saveGame: "Guardar Juego",
    newGame: "Nuevo Juego",
    editGame: "Editar Juego",
    source: "Fuente",
    preview: "Previsualizar",
    edit: "Editar",
    saveChanges: "Guardar Cambios",
    cancel: "Cancelar",
    intelligenceBreachAudit: "Auditoría de Brechas",
    breachOrigin: "Origen",
    reported: "Reportado",
    breachTestimony: "Testimonio",
    noTestimonyRecorded: "Sin testimonios detallados",
    closeLog: "Cerrar Log",
    terminateIntelligence: "Borrar Contenido",
    appearanceInLiveFeed: "Vista en Feed",
    detailPagePreview: "Vista de Página",
    titleKo: "Título (KO)",
    titleEn: "Título (EN)",
    summaryKo: "Resumen (KO)",
    summaryEn: "Resumen (EN)",
    contentKo: "Contenido (KO)",
    contentEn: "Contenido (EN)",
    editIntelligence: "Editar Contenido",
    intelligenceDesc: "Gestiona feeds de comunidad",
    awardPoints: "Dar Puntos",
    awardPointsDesc: "Otorga puntos al agente.",
    awardSuccess: "puntos otorgados con éxito.",
    deleteUserSuccess: "Cuenta y datos borrados.",
    deleteNewsSuccess: "Artículo y archivos borrados.",
    awardAmount: "Cantidad",
    awardReason: "Razón",
    awardAction: "Dar",
    adminReward: "Premio Especial Admin",
    refreshPage: "Refrescar Página",
    refreshSuccess: "Cache limpia y página refrescada.",
    awardPointsUserDesc: "Dar puntos a {{name}}.",
    syncingAlerts: "Sincronizando alertas...",
    personnelActivityLogs: "Logs de Actividad",
    newsTalk: "Comentarios News",
    foundCount: "{{count}} items encontrados",
    syncingLogs: "Sincronizando logs...",
    noActivityLogs: "Sin registros",
    page: "Página",
    of: "de",
    breachReport: "Informe Brecha",
    noSpecificReason: "Sin razón específica",
    scoutId: "ID Scout",
    items: "Items",
    manageNoticesDesc: "Gestiona avisos y popups",
    syncingIntelHub: "Sincronizando Hub...",
    noActiveCommunications: "Sin comunicaciones activas",
    status: "Estado",
    live: "Vivo",
    offline: "Offline",
    immediate: "Inmediato",
    infinite: "Infinito",
    language: "Idioma",
    korean: "Coreano",
    english: "Inglés",
    translateToEn: "Traducir a EN",
    translateToKr: "Traducir a KR",
    publishStatus: "Estado Publicación",
    noBannerSelected: "Sin Banner",
    enterVisualTheme: "Introduce tema visual",
    forgeNewVisual: "Forjar Visual",
    delete: "Borrar",
    footyMaster: "Footy Master",
    manageFootyMasterDesc: "Gestionar cuestionarios basados en DB para FQ Test",
    addNewQuiz: "Añadir Nuevo Quiz",
    searchQuizzes: "Buscar cuestionarios o categorías...",
    questionKo: "Pregunta (KO)",
    difficulty: "Dificultad",
    langs: "Idiomas",
    syncingQuizzes: "Sincronizando Quizzes...",
    noQuizzesFound: "No se encontraron quizzes",
    editQuiz: "Editar Quiz",
    newQuiz: "Nuevo Quiz",
    fqTestDbEntry: "Entrada de base de datos FQ Test",
    correctIndex: "Índice Correcto",
    option: "Opción",
    correct: "Correcto",
    explanation: "Explicación",
    saveQuizAsset: "Guardar Activo de Quiz",
    deleteQuiz: "Borrar Quiz",
    deleteQuizConfirm: "¿Estás seguro de que quieres eliminar este quiz permanentemente? Esta acción no se puede deshacer.",
    generateWithAI: "Generar con IA",
    aiDraftGenerated: "Borrador de IA generado (solo coreano, por favor traduzca o complete otros)",
    enterCategoryFirst: "Por favor, introduce una categoría primero",
  },
  fr: {
    adminTitle: "Centre de Contrôle Admin",
    operationsHub: "Hub d'Opérations",
    personnel: "Personnel",
    intelligence: "Intelligence",
    notices: "Avis",
    securityAlerts: "Alertes Sécurité",
    analytics: "Analytique",
    authorizing: "Autorisation session...",
    exportIntel: "Exporter Intelligence",
    recentAgents: "Agents Récents",
    networkSecure: "Réseau Sécurisé",
    allVerified: "Toutes transmissions vérifiées",
    deletePersonnel: "Supprimer fiche personnel ?",
    deleteDesc: "Ceci effacera tout l'historique et données de ce scout.",
    terminateUser: "TERMINER UTILISATEUR",
    terminateBroadcast: "Terminer diffusion ?",
    deleteBroadcastDesc: "Voulez-vous supprimer ce contenu ? Irréversible.",
    changeAccess: "Changer niveau accès ?",
    accessLevelDesc: "Modifie l'accréditation du personnel.",
    incidentReport: "Rapport Incident",
    reporterTestimony: "Témoignage Informateur",
    noTestimony: "Aucun témoignage supp.",
    auditLog: "Audit Complet",
    modifyPerms: "Modifier Permissions",
    alerts: "Alertes Système",
    noAlerts: "Aucune alerte ces 3 jours",
    newAgent: "Nouvel Agent Recruté",
    reportFiled: "Rapport de Sécurité Déposé",
    justNow: "À l'instant",
    threeDaysAlert: "Alertes des dernières 72h",
    overview: "Aperçu",
    users: "Utilisateurs",
    content: "Contenu",
    settings: "Paramètres",
    adminControl: "Contrôle Admin",
    exitConsole: "Quitter Console",
    opsHubDesc: "Trafic réseau et analytique personnel",
    personnelAlerts: "Alertes Personnel",
    totalAgents: "Total Agents",
    intelFeed: "Flux Intelligence",
    activeReports: "Rapports Actifs",
    growthAnalytics: "Analytique Croissance",
    growthDesc: "Comparaison recrues vs activité",
    activeSectors: "Secteurs Actifs",
    sectorDesc: "Distribution par ligue",
    recentPersonnel: "Agents Récents",
    personnelDesc: "Nouvelles recrues réseau",
    personnelManageDesc: "Gérer les membres du réseau global",
    noResultsFound: "Aucun résultat",
    viewAll: "Voir Tout",
    activeFans: "Fans Actifs",
    feedActivity: "Activité Flux",
    newAgents: "Nouveaux Agents",
    communityActivity: "Talk Communauté",
    totalCommentsReplies: "Total commentaires et réponses",
    safetyClearance: "Sécurité : 98%",
    securityAlertsDesc: "Brèches signalées",
    accessLevel: "Niveau Accès",
    recruitmentDate: "Date Recrutement",
    broadcastingAsset: "Actif Diffusion",
    sector: "Secteur",
    riskLevel: "Niveau Risque",
    timestamp: "Timestamp",
    ops: "Ops",
    searchPersonnel: "Chercher par nom, email ou ID...",
    searchBroadcast: "Chercher par titre ou source...",
    critical: "Critique",
    secure: "Sécurisé",
    last7days: "7 derniers jours",
    last30days: "30 derniers jours",
    last3months: "3 derniers mois",
    createNotice: "Créer Avis",
    filterDate: "Filtrer Date",
    allActivities: "Total",
    hide: "Masquer",
    unhide: "Afficher",
    hidden: "Masqué",
    visibilityChanged: "Visibilité mise à jour",
    save: "Sauver",
    systemProtocols: "Protocoles",
    maintenanceMode: "Mode Maintenance",
    maintenanceDesc: "Suspendre transmissions publiques",
    guestIntelligence: "Intelligence Invité",
    guestIntelDesc: "Autoriser rapports scouts non vérifiés",
    aiNeuralEngine: "Moteur Neuronal IA",
    primaryModel: "Modèle Principal",
    reportLength: "Longueur Rapports",
    latencyOptimizations: "Optimisation Latence",
    latencyDesc: "Utilisation de tokens pensée pour la précision.",
    coreRepository: "Dépôt Central",
    hostStatus: "État Host",
    cacheDensity: "Densité Cache",
    logRetention: "Rétention Logs",
    flushCache: "Vider Cache",
    securityCredentials: "Accréditations",
    operational: "Opérationnel",
    configSaved: "Configuration sauvée.",
    flushConfirm: "Vider cache global ?",
    cachePurged: "Cache vidé avec succès.",
    inquiries: "Demandes",
    players: "Joueurs",
    playerAndTransferManagement: "Gestion Joueurs",
    playerManagementDesc: "Données marché et profils",
    latestTransfers: "Derniers Transferts",
    topTransfers: "Gros Transferts",
    groupList: "Listes Groupes",
    playerSearchPlaceholder: "Chercher joueur ou équipe...",
    addItem: "Ajouter Item",
    playerIntel: "Infos Joueur",
    movement: "Mouvement",
    valueFee: "Valeur / Prix",
    noItemsFound: "Aucun item trouvé",
    createGroup: "Créer Groupe",
    editGroup: "Éditer Groupe",
    addPersonnel: "Ajouter Joueur",
    editPersonnel: "Éditer Joueur",
    deleteGroup: "Supprimer Groupe",
    deleteItem: "Supprimer Item",
    deleteGroupConfirmDesc: "Supprimer groupe ? Toutes les données seront perdues.",
    deleteItemConfirmDesc: "Supprimer données joueur ?",
    deleteConfirm: "Confirmer Suppression",
    deleteConfirmDesc: "Supprimer ce contenu ? Irrécupérable sur le serveur.",
    selectLeagueDate: "Choisir ligue et date d'abord",
    noGamesFound: "Aucun match à cette date",
    foundGames: "{{count}} matchs trouvés",
    gameInfoApplied: "Infos appliquées",
    highlightUpdated: "Highlight mis à jour",
    highlightCreated: "Highlight créé",
    deletedSuccess: "Supprimé avec succès",
    editShort: "Éditer Short",
    newShort: "Nouveau Short",
    shortUpdated: "Short mis à jour",
    shortCreated: "Short créé",
    highlights: "Highlights",
    manageGamesDesc: "Gérer le catalogue jeux",
    gameCreated: "Jeu créé",
    iconEmoji: "Icône (Emoji)",
    loadInquiriesFailed: "Échec chargement demandes.",
    inquiryStatusUpdated: "Statut mis à jour.",
    updateFailed: "Échec mise à jour.",
    intelAsset: "Actif Intel",
    timeline: "Chronologie",
    enterContentTranslate: "Entrez contenu à traduire.",
    editCommunication: "Éditer Com.",
    newBroadcast: "Nouvelle Diffusion",
    sysIntelModule: "Module Intel",
    transmissionStart: "Début Transmission",
    transmissionExpiry: "Fin Transmission",
    activeBanner: "Banner Active",
    aiContentForge: "Forge IA",
    assetLibrary: "Bibliothèque Actifs",
    deployIntelligence: "Déployer Intelligence",
    deleteNotice: "Supprimer Avis",
    deleteNoticeConfirmDesc: "Supprimer cet avis ? Irréversible.",
    newsArticle: "Article News",
    feedComment: "Commentaire Flux",
    matchTalk: "Talk Match",
    contentDeleted: "Contenu supprimé.",
    deleteError: "Erreur suppression.",
    reportsConfirmDesc: "Supprimer contenu signalé définitivement ?",
    approveDeletion: "Approuver Suppression",
    manageReportsDesc: "Gérer signalements incidents",
    searchReportsPlaceholder: "Chercher par raison, informateur...",
    breachContextReason: "Contexte / Raison",
    reporter: "Informateur",
    clearingCache: "Vidage cache...",
    manageSettingsDesc: "Gérer moteur et politiques",
    sysMaintenance: "Maintenance",
    flushCacheDesc: "Vider données locales",
    clearing: "Vidage...",
    dbStatus: "État DB",
    apiNode: "Nœud API",
    versionControl: "Version Control",
    coreVersion: "Version Core",
    neuralInterface: "Interface Neurone",
    highlightsManage: "Gestion Highlights",
    highlightsDesc: "Gérer vidéos highlights",
    addNew: "Ajouter Nouveau",
    search: "Chercher...",
    allCountries: "Tous Pays",
    itemsPerPage: "Items",
    matchInfo: "Infos Match",
    embedId: "ID Embed",
    matchId: "ID Match",
    date: "Date",
    editHighlight: "Éditer Highlight",
    newHighlight: "Nouveau Highlight",
    quickGameSelection: "Sélection Rapide",
    searchLeague: "Chercher ligue...",
    selectLeague: "Choisir Ligue",
    majorLeagues: "Grandes Ligues",
    searchResults: "Résultats",
    allLeagues: "Toutes Ligues",
    saveHighlight: "Sauver Highlight",
    shorts: "Shorts",
    shortsManage: "Gestion Shorts",
    shortsDesc: "Gérer YouTube Shorts",
    videoId: "ID Vidéo",
    channelName: "Chaîne",
    channelImage: "Image Chaîne",
    saveShort: "Sauver Short",
    isHidden: "Masqué",
    customerInquiries: "Demandes Clients",
    manageInquiries: "Gérer support",
    allStatus: "Tous Statuts",
    pending: "En attente",
    answered: "Répondu",
    closed: "Clos",
    noInquiries: "Aucune demande",
    general: "Général",
    userInquiry: "Demande Utilisateur",
    adminResponse: "Réponse Admin",
    writeResponse: "Écrivez votre réponse...",
    closeWithoutAnswer: "Clore sans réponse",
    sendAnswer: "Envoyer Réponse",
    unknown: "Inconnu",
    gameStore: "Game Store",
    manageGames: "Gérer Jeux",
    gameTitle: "Titre Jeu",
    category: "Catégorie",
    iconUrl: "URL Icône",
    gameLink: "Lien Jeu",
    isNew: "Nouveau",
    saveGame: "Sauver Jeu",
    newGame: "Nouveau Jeu",
    editGame: "Éditer Jeu",
    source: "Source",
    preview: "Aperçu",
    edit: "Éditer",
    saveChanges: "Sauver Changements",
    cancel: "Annuler",
    intelligenceBreachAudit: "Audit Brèches",
    breachOrigin: "Origine",
    reported: "Signalé",
    breachTestimony: "Témoignage",
    noTestimonyRecorded: "Aucun témoignage détaillé",
    closeLog: "Fermer Log",
    terminateIntelligence: "Supprimer Contenu",
    appearanceInLiveFeed: "Vue Flux",
    detailPagePreview: "Vue Page",
    titleKo: "Titre (KO)",
    titleEn: "Titre (EN)",
    summaryKo: "Résumé (KO)",
    summaryEn: "Résumé (EN)",
    contentKo: "Contenu (KO)",
    contentEn: "Contenu (EN)",
    editIntelligence: "Éditer Contenu",
    intelligenceDesc: "Gérer flux communauté",
    awardPoints: "Donner Points",
    awardPointsDesc: "Donner points à l'agent.",
    awardSuccess: "points donnés avec succès.",
    deleteUserSuccess: "Compte et données effacés.",
    deleteNewsSuccess: "Article et fichiers effacés.",
    awardAmount: "Quantité",
    awardReason: "Raison",
    awardAction: "Donner",
    adminReward: "Prime Admin Special",
    refreshPage: "Rafraîchir Page",
    refreshSuccess: "Cache vidé et page rafraîchie.",
    awardPointsUserDesc: "Donner points à {{name}}.",
    syncingAlerts: "Sinc. alertes...",
    personnelActivityLogs: "Logs Activité",
    newsTalk: "Talk News",
    foundCount: "{{count}} items trouvés",
    syncingLogs: "Sinc. logs...",
    noActivityLogs: "Aucun log",
    page: "Page",
    of: "de",
    breachReport: "Rapport Brèche",
    noSpecificReason: "Aucune raison",
    scoutId: "ID Scout",
    items: "Items",
    manageNoticesDesc: "Gérer avis et popups",
    syncingIntelHub: "Sinc. Hub...",
    noActiveCommunications: "Aucun avis actif",
    status: "Statut",
    live: "Live",
    offline: "Offline",
    immediate: "Immédiat",
    infinite: "Infini",
    language: "Langue",
    korean: "Coréen",
    english: "Anglais",
    translateToEn: "Traduire en EN",
    translateToKr: "Traduire en KR",
    publishStatus: "Statut Publication",
    noBannerSelected: "Aucun Banner",
    enterVisualTheme: "Entrez thème visuel",
    forgeNewVisual: "Forger Visual",
    delete: "Supprimer",
    footyMaster: "Footy Master",
    manageFootyMasterDesc: "Gérer les quiz basés sur la DB pour le test FQ",
    addNewQuiz: "Ajouter un nouveau quiz",
    searchQuizzes: "Rechercher des quiz ou des catégories...",
    questionKo: "Question (KO)",
    difficulty: "Difficulté",
    langs: "Langues",
    syncingQuizzes: "Synchronisation des quiz...",
    noQuizzesFound: "Aucun quiz trouvé",
    editQuiz: "Modifier le quiz",
    newQuiz: "Nouveau quiz",
    fqTestDbEntry: "Entrée de la base de données du test FQ",
    correctIndex: "Index correct",
    option: "Option",
    correct: "Correct",
    explanation: "Explication",
    saveQuizAsset: "Enregistrer l'actif du quiz",
    deleteQuiz: "Supprimer le quiz",
    deleteQuizConfirm: "Êtes-vous sûr de vouloir supprimer définitivement ce quiz ? Cette action est irréversible.",
    generateWithAI: "Générer avec l'IA",
    aiDraftGenerated: "Brouillon IA généré (coréen uniquement, veuillez traduire ou remplir les autres)",
    enterCategoryFirst: "Veuillez d'abord saisir une catégorie",
  },
};

export const at = (lang: Language, key: string): string => {
  return adminTranslations[lang]?.[key] || key;
};
